import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import { ScrollStyles } from '@/components/styles';
import { RangeVariantType } from '@/typings/common';

export const Component = styled.div<{
  isOpen: boolean;
  rangeType: RangeVariantType;
}>`
  position: relative;
  width: 100%;
  background: ${(props) => props.theme.white_1};
  border: 1px solid ${(props) => props.theme.gray1000};
  display: inline-block;
  vertical-align: top;

  ${({ rangeType }) =>
    rangeType === 'min'
      ? css`
          border-radius: 6px 0 0 6px;
        `
      : css`
          border-radius: 0 6px 6px 0;
          margin-left: -1px;
        `}
`;

export const Select = styled.button`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 15px 10px;
  width: 100%;
  height: 38px;
`;

export const Label = styled.div<{
  isSelectedItem: boolean;
}>`
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.gray1500};

  ${({ isSelectedItem }) =>
    isSelectedItem &&
    css`
      color: ${(props) => props.theme.black200};
    `}
`;

export const SvgWrapper = styled.div<{ isOpen: boolean }>`
  svg {
    transform: rotate(0deg);
    transition: all 0.3s ease-in-out;

    path {
      fill: ${(props) => props.theme.black200};
    }
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      svg {
        transform: rotate(180deg);

        path {
          fill: ${(props) => props.theme.main};
        }
      }
    `}
`;

export const Content = styled.div<{ isOpen: boolean }>`
  z-index: 5;
  pointer-events: none;
  position: absolute;
  top: 40px;
  width: 100%;
  max-height: 0;
  overflow-y: auto;
  transition: all 0.3s ease-in-out;
  background: ${(props) => props.theme.white_1};
  opacity: 0;
  border: 1px solid ${(props) => props.theme.gray1000};
  box-shadow: ${(props) => props.theme.blackShadow100};
  ${ScrollStyles};

  ${({ isOpen }) =>
    isOpen &&
    css`
      pointer-events: auto;
      opacity: 1;
      max-height: 280px;
      transition: all 0.3s ease-in-out;
    `}
`;

export const ListItem = styled.div<{ isActive: boolean; disabled: boolean }>`
  cursor: pointer;
  height: 39px;
  padding: 10px 15px;
  font-size: 16px;
  line-height: 19px;
  transition: all 0.3s ease-in-out;
  color: ${(props) => props.theme.blue100};

  &:hover {
    background: ${(props) => props.theme.gray300};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 700;
      color: ${(props) => props.theme.black200};

      svg {
        flex: 0 0 23px;
        height: 19px;

        path {
          fill: ${colors.main};
          stroke: ${colors.main};
        }
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export const ClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 20px;
  height: 20px;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.3s;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 9px;
    height: 9px;

    path {
      fill: ${(props) => props.theme.main};
    }
  }
`;

export const NoOptions = styled.p`
  padding: 10px 15px;
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.blue100};
`;
